// extracted by mini-css-extract-plugin
export default {"meals":"AvailableProducts_meals__Ji-yk","meals-appear":"AvailableProducts_meals-appear__NPKhQ"};